// @flow
import ko from 'rgs-knockout';
import _ from 'lodash';
import EventEmitter from 'events';

import { JSableOmitPrivateMixin } from 'jsable';

import type { Observable, Disposable } from 'rgs-knockout/types';
import type { ITableComponent } from 'ko-component-adaptive-table/js/contract.flow';

export const EVENT_SORTING_CHANGE = '__sorting_term_change';

export type TableSortingParams = {
	sortBy: string,
	isSortAsc: Boolean,
	enabled: Boolean,
}

export class TableSortingModel
	extends JSableOmitPrivateMixin(EventEmitter) implements ITableComponent {

	_params: TableSortingParams;
	sortBy: Observable<string>;
	isSortAsc: Observable<boolean>;
	currentSortBy: Observable<string>;
	_currentSortBySubscribe: Disposable;

	constructor (params: TableSortingParams) {
		super();

		this._params = _.defaults({}, params, {
			isSortAsc: true,
			sortBy: '',
			enabled: false,
		});
		
		this.sortBy = ko.observable(this._params.sortBy)
			.extend({ toFromJS: true });

		this.isSortAsc = ko.observable(this._params.isSortAsc)
			.extend({ toFromJS: true });

		this.currentSortBy = ko.observable(this._params.sortBy)
			.extend({ notify: 'always' });

		this._subscribeToCurrentSortBy();
	}

	_subscribeToCurrentSortBy = () => {
		if (this._params.enabled) {
			this._currentSortBySubscribe = this.currentSortBy.subscribe(currentSortBy => {
				const nextSortDir = this.sortBy() === currentSortBy
					? !this.isSortAsc()
					: true;

				this.sortBy(currentSortBy);
				this.isSortAsc(nextSortDir);

				this._emitSortChange();
			});
		}
	};

	_emitSortChange () {
		this.emit(EVENT_SORTING_CHANGE);
	}

	getFacade = () => ({
		sortBy: this.sortBy,
		isSortAsc: this.isSortAsc,
	});

	dispose () {
		if (this._currentSortBySubscribe) {
			this._currentSortBySubscribe.dispose();
		}
	}
}
